import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpHeaders, HttpInterceptorFn, HttpRequest } from "@angular/common/http";
import { inject } from "@angular/core";
import { Router } from "@angular/router";
import { OAuthService } from "angular-oauth2-oidc";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { environment } from "../../../../environments/environment";

export const headerInterceptor: HttpInterceptorFn = (req, next) => {
    const router = inject(Router);
    const oidcService = inject(OAuthService);

    if (!req.url.includes(environment.azureAD.host)) {
        const versionHeader = req.headers.get('Version');
        const openIdValue = oidcService.getAccessToken() ? `OpenId ${oidcService.getAccessToken()}` : 'null';
        const baseHeaders: { [name: string]: string } = {
            'Content-Type': 'application/json',
            'OpenId': openIdValue,
            'apiVersion': '1',
            'SessionId': crypto.randomUUID()
        };
        const authReq = versionHeader
            ? req.clone({ headers: new HttpHeaders({ ...baseHeaders, 'version': versionHeader }) })
            : req.clone({ headers: new HttpHeaders(baseHeaders) });

        return handleResponse(next, authReq, router);
    }
    return handleResponse(next, req, router);
};

function handleResponse(next: HttpHandlerFn, req: HttpRequest<unknown>, router: Router): Observable<HttpEvent<unknown>> {
    return next(req).pipe(catchError((err: HttpErrorResponse) => {
        if (err.status === 401) {
            router.navigate(['acceso']);
        }
        return throwError(() => err.error);
    }));
}
